var i18nInstance;
export var setI18n = function setI18n(instance) {
  i18nInstance = instance;
};
export var getI18n = function getI18n() {
  return i18nInstance;
};